<template>
  <q-dialog v-model="confirm" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="lock" color="negative" text-color="white" />
        <span class="q-ml-sm">Do you want to reset password of {{ firstname }} {{ lastname }}? </span>
        <span class="q-ml-sm">Password will be reset to default:  "@escuela"</span>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat label="Cancel" color="warning" v-close-popup />
        <q-btn flat :loading="isSubmitted" label="Reset Now" color="positive" @click="resetPassword" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { useQuasar } from 'quasar' 
import { ref } from 'vue'
import axios from 'axios'
import EventBus from "@/EventBus"
export default {
  setup () {
    const token = ref(window.$cookies.get(process.env.VUE_APP_API_KEY).token)
    const $q = useQuasar()
    const confirm = ref(false)
    const id = ref(null)
    const currentStatus = ref(null)
    const firstname = ref(null)
    const lastname = ref(null)
    const isSubmitted = ref(false)

    EventBus.on("resetPassword",(val) => {
        id.value = val.obj.id
        currentStatus.value = val.obj.status
        firstname.value = val.obj.firstname
        lastname.value = val.obj.lastname
        confirm.value = val.status
    })

    const resetPassword = () => {
      var formData = {
          "id":id.value,
        }

      isSubmitted.value = true; 
      axios.post(process.env.VUE_APP_API_URL + '/reset-password',formData,{
        headers: { 'Authorization': `Bearer ${token.value}`},
      }).then((response) => {
          isSubmitted.value = false
          confirm.value = false
          $q.notify({
            color: 'positive',
            textColor: 'white',
            icon: 'check_circle',
            message: response.data.message
          })
          EventBus.emit("refreshData")
        }).catch((e) => {
         isSubmitted.value = false
         $q.notify({
            color: 'negative',
            textColor: 'white',
            icon: 'warning',
            message: e.response.data.message
          })
      })
    }

    return {
      token,
      confirm,
      id,
      currentStatus,
      firstname,
      lastname,
      isSubmitted,
      resetPassword
    }
  }
}
</script>